import { DEFAULT_TIME_FRAME } from '../utils/normalizeAvailability';
import {
  CLICK_EMAIL_US_REQUEST,
  CLICK_EMAIL_US_SUCCESS,
  CLICK_EMAIL_US_FAILURE,
  DATA_COPY_SUBMIT_REQUEST,
  DATA_COPY_SUBMIT_SUCCESS,
  DATA_COPY_SUBMIT_FAILURE,
  CHECK_CHAT_AVAILABILITY_REQUEST,
  CHECK_CHAT_AVAILABILITY_SUCCESS,
  CHECK_CHAT_AVAILABILITY_FAILURE,
  UPDATE_ISSUE_SELECTION,
  SET_DEFAULT_CONTACT_NOTE,
  SET_UPLOADED_FILES,
  SET_ENERGY_SCHEDULING_TEAM,
  REQUEST_SENT,
  REQUEST_FAILED,
  DATA_COPY_SUBMIT_DUPLICATE,
  REQUEST_IN_PROGRESS,
  REQUEST_SENDING,
  CHECK_ACCOUNT_REQUEST,
  SET_COMPLETED_TROUBLESHOOTING_GUIDE,
  SET_TROUBLESHOOTING_GUIDE,
  SET_TROUBLESHOOTING_SUPPORT_OVERRIDES,
  CHAT_START,
} from '../types';

const initialState = {
  isEmailSent: false,
  dataRequestStatus: REQUEST_FAILED,
  chatAvailabilityRequestStatus: REQUEST_FAILED,
  isChatEnabled: false,
  isChatOngoing: false,
  clickEmailUsStatus: '',
  completedTroubleshootingGuide: false,
  troubleshootingSupportOverrides: {
    chatTeam: null,
    symptomCode: null,
  },
  chatWidgetParams: {},
  serviceMetricsResponseMap: {},
  timeFrame: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CLICK_EMAIL_US_REQUEST:
      return {
        ...state,
        clickEmailUsStatus: REQUEST_SENDING,
      };
    case CLICK_EMAIL_US_SUCCESS:
      return {
        ...state,
        isEmailSent: true,
        clickEmailUsStatus: REQUEST_SENT,
      };
    case CLICK_EMAIL_US_FAILURE:
      return {
        ...state,
        isEmailSent: false,
        clickEmailUsStatus: REQUEST_FAILED,
      };
    case CHECK_ACCOUNT_REQUEST:
      return {
        ...state,
        clickEmailUsStatus: '',
      };
    case DATA_COPY_SUBMIT_REQUEST:
      return {
        ...state,
        dataRequestStatus: REQUEST_SENDING,
      };
    case DATA_COPY_SUBMIT_SUCCESS:
      return {
        ...state,
        dataRequestStatus: REQUEST_SENT,
      };
    case DATA_COPY_SUBMIT_FAILURE:
      return {
        ...state,
        dataRequestStatus: REQUEST_FAILED,
      };
    case DATA_COPY_SUBMIT_DUPLICATE:
      return {
        ...state,
        dataRequestStatus: REQUEST_IN_PROGRESS,
      };
    case CHECK_CHAT_AVAILABILITY_SUCCESS:
      return {
        ...state,
        chatAvailabilityRequestStatus: REQUEST_SENT,
        isChatEnabled: true,
        chatWidgetParams: action.payload?.chatWidgetParams ?? {},
        serviceMetricsResponseMap: action.payload?.serviceMetricsResponseMap ?? {},
        timeFrame: {
          startTime: action.payload?.startTime ?? DEFAULT_TIME_FRAME.startTime,
          endTime: action.payload?.endTime ?? DEFAULT_TIME_FRAME.endTime,
          timeZone: action.payload?.timeZone ?? DEFAULT_TIME_FRAME.timeZone,
        },
      };
    case CHECK_CHAT_AVAILABILITY_REQUEST:
      return {
        ...state,
        chatAvailabilityRequestStatus: REQUEST_IN_PROGRESS,
        isChatEnabled: false,
      };
    case CHECK_CHAT_AVAILABILITY_FAILURE:
      return {
        ...state,
        chatAvailabilityRequestStatus: REQUEST_FAILED,
        isChatEnabled: false,
      };
    case CHAT_START:
      return {
        ...state,
        isChatEnabled: false,
        isChatOngoing: true,
      };
    case UPDATE_ISSUE_SELECTION:
      return {
        ...state,
        firstChoice: action.payload.firstChoice,
        secondChoice: action.payload.secondChoice,
      };
    case SET_DEFAULT_CONTACT_NOTE:
      return {
        ...state,
        defaultContactNote: action.payload,
      };
    case SET_UPLOADED_FILES:
      return {
        ...state,
        files: action.payload,
      };
    case SET_ENERGY_SCHEDULING_TEAM:
      return {
        ...state,
        energySchedulingTeam: action.payload,
      };
    case SET_TROUBLESHOOTING_GUIDE:
      return {
        ...state,
        troubleshootingGuide: action.payload,
      };
    case SET_COMPLETED_TROUBLESHOOTING_GUIDE:
      return {
        ...state,
        completedTroubleshootingGuide: action.payload,
      };
    case SET_TROUBLESHOOTING_SUPPORT_OVERRIDES:
      return {
        ...state,
        troubleshootingSupportOverrides: action.payload,
      };
    default:
      return state;
  }
};
